/* RESPONSIBLE TEAM: team-inbox */
import Model, { attr } from '@ember-data/model';

export default class SavedReplyTypeModel extends Model {
  @attr('number') appId;
  @attr('string') name;
  @attr('string') displayName;
}
